import { Component, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { TableColumn } from '../table.column';
import { ProgressTableColumn } from './ProgressTableColumn';

@Component({
  selector: 'app-table-widget-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent extends WidgetComponent implements OnInit {

  static defaultColor = "lightseegreen";
  static defaultMode = 'determinate';

  _width = "150px";
  get width() {
    if (!this._color) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
        this._width = column.width + "px";
      }  
    }
    return this._width;
  }

  _height = "20px";
  get height() {
    if (!this._color) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
        this._height = column.height + "px";
      }  
    }
    return this._height;
  }

  _color: any;
  get color() {
    if (!this._color) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
        this._color = column.color;
      } else {
        this._color = ProgressComponent.defaultColor;
      }  
    }
    return this._color;
  }

  _mode: any;
  get mode() {
    if (!this._mode) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
        this._mode = column.mode;
      } else {
        this._mode = ProgressComponent.defaultMode;
      }  
    }
    return this._mode;
  }

  get value() {
    return this.getContent();
  }

  _quantity: any;
  get quantity() {
    if (!this._quantity) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
  
        this._quantity = column.getQuantity(this.tableElement.getData());
      } else {
        this._quantity = TableColumn._getData(this.tableElement.getData(), this.tableColumn.column);
      }  
    }
    return this._quantity;
  }

  _bufferValue: any;
  get bufferValue() {
    if (!this._bufferValue) {
      if (this.tableColumn instanceof ProgressTableColumn) {
        const column: ProgressTableColumn = this.tableColumn as ProgressTableColumn;
  
        if (column.bufferValueColumn) {
          this._bufferValue = TableColumn._getData(this.tableElement.getData(), column.bufferValueColumn);
        } else {
          this._bufferValue = null;
        }
      } else {
        this._bufferValue = null;
      }  
    }
    return this._bufferValue;
  }

  // tslint:disable-next-line: deprecation
  constructor(ngEl: ElementRef, renderer: Renderer2) {
    super(ngEl, renderer);
  }

  ngOnInit() {
  }
}
